<template>
  <div>
    <Card>
      <Divider orientation="left">
        <h2>全局开关</h2>
      </Divider>
      <div style="display: flex;justify-content: flex-end;">
        <Button  v-if="buttonMenu['/global/edit']" type="primary" @click="handleSetting()" :loading="submitLoading">提交</Button>

      </div>
      <Form @submit.native.prevent :label-width="230">
        <Row :gutter="20">
          <Col :span="24">
          <FormItem label="开屏广告">
            <i-switch v-model="form.openAds" :disabled="!buttonMenu['/global/1']"></i-switch>
          </FormItem>
          </Col>
          <Col :span="24">
          <Row>
            <Col :span="8" >
            <FormItem >
              <template #label>
                <Poptip trigger="hover" transfer placement="left">
                  <Icon style="cursor:pointer;margin-right:10px" type="md-help-circle" />
                  <template #content>
                    广告解锁开启后，短剧内广告解锁开关也需开启，否则不生效;<br/>
                    反之短剧广告解锁开关开启，全局广告开关关闭，也不生效。
                  </template>
                </Poptip>
                广告解锁
              </template>
              <i-switch :disabled="!buttonMenu['/global/2']" v-model="form.adsUnlock" :before-change="() => beforeChange('adsUnlock')"
                @on-change="changeAds"></i-switch>
            </FormItem>
            </Col>
            <Col :span="16" v-if="form.adsUnlock">
            <FormItem label="单账号每日最大可观看广告数">
              <InputNumber :disabled="!buttonMenu['/global/2']" style="width: 200px;" :max="99999" v-model="form.adsUnlockNum" placeholder="整数，不少于1" :min="1" />
            </FormItem>
            </Col>
          </Row>
          </Col>
          <Col :span="24">
          <FormItem label="金币解锁">
            <i-switch :disabled="!buttonMenu['/global/3']" v-model="form.coinsUnlock" :before-change="() => beforeChange('coinsUnlock')"></i-switch>
          </FormItem>
          </Col>
          <Col :span="24">
          <FormItem label="VIP解锁">
            <i-switch :disabled="!buttonMenu['/global/4']" v-model="form.vipUnlock" :before-change="() => beforeChange('vipUnlock')"></i-switch>
          </FormItem>
          </Col>
          <Col :span="24">
          <FormItem label="开通VIP入口">
            <i-switch :disabled="!buttonMenu['/global/5']" v-model="form.vipChannel"></i-switch>
          </FormItem>
          </Col>
          <Col :span="24">
          <FormItem label="充值金币入口">
            <i-switch :disabled="!buttonMenu['/global/6']" v-model="form.coinsRecharge"></i-switch>
          </FormItem>
          </Col>
        </Row>

      </Form>

      <Divider orientation="left">
        <h2>页面文案</h2>
      </Divider>
      <Form @submit.native.prevent :label-witdh="150">
          <FormItem label="金币商店">
          <Input type="textarea" :disabled="!buttonMenu['/global/text']" v-model="form.shopDesc" :autosize="{ minRows: 5 }" style="width:50%" show-word-limit
            :maxlength="200" />
        </FormItem>
        </Form>
    </Card>

  </div>
</template>

<script>
import { getGlobalSetting, editGlobalSetting } from '@/api/global'
export default {
  data() {
    return {
      form: {},
      submitLoading: false
    }
  },
  computed:{
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('server/global')
      const obj = {}
      li.forEach(i => {
        obj[i.menuPath] = true
      })
      return obj
    }
  },
  methods: {
    getSetting() {
      getGlobalSetting().then(r => {
        this.form = { ...r.data }
      })
    },
    handleSetting() {
      if (this.form.adsUnlock && !this.form.adsUnlockNum) {
        this.$Message.error('请输入广告解锁集数')
        return
      }
      this.submitLoading = true
      editGlobalSetting({
        ...this.form
      }).then(r => {
        this.$Message.success('操作成功')
        this.getSetting()
        this.submitLoading = false
      }).catch(e => {
        this.submitLoading = false
      })
    },
    beforeChange(key) {
      const keys = ['adsUnlock', 'coinsUnlock', 'vipUnlock'].filter(el => el !== key)

      if (!this.form[keys[0]] && !this.form[keys[1]] && this.form[key]) {
        this.$Message.error('广告解锁、金币解锁与VIP解锁至少开启一项')
        return new Promise(() => { })
      }

      if (this.form[key]) {
        this.$Modal.confirm({
          title: '确定要关闭该功能吗？',
          onOk: () => {
            this.form[key] = !this.form[key]
          },
          onCancel: () => {
          }
        })
        return new Promise(() => { })
      }
    },
    changeAds(e) {
      if (e && !this.form.adsUnlockNum) {
        this.form.adsUnlockNum = 1
      }
    }
  },
  mounted() {
    this.getSetting()
  }
}
</script>

<style lang="less" scoped>
/deep/.ivu-form-item-label {
  font-size: 15px;
}
</style>
